import type { GlobalPriceRangeObject } from '@/context/listings/types'

export const getHighestFilterPrice = (globalPriceObject: GlobalPriceRangeObject, showAllInPrice = false): number => {
    return showAllInPrice
        ? Math.min(globalPriceObject.medianAllInPrice * 4, globalPriceObject.highestAllInPrice)
        : Math.min(globalPriceObject.medianPrice * 4, globalPriceObject.highestPrice)
}
